import { LogLevel } from "@azure/msal-browser";

const ua = window.navigator.userAgent;
const msie = ua.indexOf("MSIE ");
const msie11 = ua.indexOf("Trident/");
const msedge = ua.indexOf("Edge/");
const firefox = ua.indexOf("Firefox");
const isIE = msie > 0 || msie11 > 0;
const isEdge = msedge > 0;
const isFirefox = firefox > 0;

const { REACT_APP_MSAL_CLIENT_ID, REACT_APP_BASE_URL, REACT_APP_MSAL_AUTHORITY_URI, REACT_APP_MSAL_TENANT_ID } = process.env;

export const msalConfig = {
    auth: {
        knownAuthorities: [REACT_APP_MSAL_AUTHORITY_URI],
        clientId: REACT_APP_MSAL_CLIENT_ID,
        redirectUri: REACT_APP_BASE_URL,
        authority: `https://${REACT_APP_MSAL_AUTHORITY_URI}/${REACT_APP_MSAL_TENANT_ID}/`,
        postLogoutRedirectUri: "/",
    },
    cache: {
        cacheLocation: "sessionStorage",
        storeAuthStateInCookie: isIE || isEdge || isFirefox,
    },
    system: {
        allowNativeBroker: false,
        loggerOptions: {
            loggerCallback: (level, message, containsPii) => {
                if (containsPii) {
                    return;
                }
                switch (level) {
                    case LogLevel.Error:
                        console.debug(message);
                        break;
                    case LogLevel.Info:
                        console.debug(message);
                        break;
                    case LogLevel.Verbose:
                        console.debug(message);
                        break;
                    case LogLevel.Warning:
                        console.debug(message);
                        break;
                    default:
                        return;
                }
            },
            piiLoggingEnabled: false,
        },
        windowHashTimeout: 60000,
        iframeHashTimeout: 6000,
        loadFrameTimeout: 0,
    },
};

export const loginRequest = {
    scopes: [],
    extraQueryParameters: {
        max_age: 28800 //8 hours
    }
};

export const registerRequest = {
    scopes: ["User.Read"],
    prompt: "create",
    extraQueryParameters: {
        max_age: 28800 //8 hours
    }
};